module.exports = __webpack_public_path__ + "img/11.2d2f991a.jpg";